module.exports = __webpack_public_path__ + "media/img/frontend_application/map/malaysia-16b51c12564384c41102074311929cf0.webp";